export default {
    // 八大神校
    offerList: {
        "Harvard": {
            cate: "Harvard",
            count: "27",
            image: "20220404074805.jpg",
            list: [{
                    "title": "尖叫：2025入学，哈佛大学offer！",
                    "link": "https://mp.weixin.qq.com/s/AHctt0tGEvI9cCz8Kt8QUg",
                    "serial_number": 1
                }, {
                    "title": "哥大还没交，哈佛就录取我啦！2025冲冲冲！",
                    "link": "https://mp.weixin.qq.com/s/iEMJJsYPIql0ba2mCT7K7Q",
                    "serial_number": 1
                },
                {
                    "title": "大年初二：哈佛大学全额奖学金offer来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/Q3pB4MepKYlO51T0uyVzEg?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "大年初三：又是Harvard全奖offer！2025秋波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/7kaPlr4wn9Iwb1o4E6taTQ?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "哈佛保底，热门offer，超级保底！",
                    "link": "https://mp.weixin.qq.com/s/YMVQTT-tiI0DCt4NzpmNjA?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "Harvard DS录取来啦！2025秋季开学！",
                    "link": "https://mp.weixin.qq.com/s/HbMf53otj6GpUu-rmR9P7w?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "感谢世毕盟，哈佛大学DS录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/YJInogKkC4h6HARKjgsbww?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 Offer | 吃惊！第一个正式录取来自哈佛！",
                    "link": "https://mp.weixin.qq.com/s/Z5Y5t8JyKqLbmqBsN8YCbA?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "提前申请结束，哈佛DS offer抵达！",
                    "link": "https://mp.weixin.qq.com/s/8vCOA42Cm1jh2Ok8esNMSg?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "哈佛offer来啦，哥大4000的留位费省啦！",
                    "link": "https://mp.weixin.qq.com/s/Exrz17pxwlBSxuFcA0XS1w?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "非常满足：哈佛大学全奖offer，相约波士顿！",
                    "link": "https://mp.weixin.qq.com/s/VeEnFNsKwb0O80PFvrcyPw",
                    "serial_number": 1
                },
                {
                    "title": "创造历史：Harvard全额奖学金！来自西交利物浦大学！",
                    "link": "https://mp.weixin.qq.com/s/xN42tj6ns0t8lO1CjAx6-g",
                    "serial_number": 1
                },
                {
                    "title": "爆炸：哈佛全奖，又来自【西交利物浦大学】！！！！",
                    "link": "https://mp.weixin.qq.com/s/H1HVMeIsUrJ90JiChIYg-A",
                    "serial_number": 1
                },
                {
                    "title": "Harvard环境健康offer，2025相约波士顿！",
                    "link": "https://mp.weixin.qq.com/s/arFERCx0vP-HsEAwVB6RPA",
                    "serial_number": 1
                },
                {
                    "title": "纠结了~我收到了第2个哈佛大学offer~",
                    "link": "https://mp.weixin.qq.com/s/qnyYfkslp__DUObNl8_l5Q",
                    "serial_number": 1
                },
                {
                    "title": "Harvard健康数据科学，2025秋，波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/2xHkYLWFi44_z9eTP6baRA",
                    "serial_number": 1
                },
                {
                    "title": "Harvard商学院博士全奖，offer大礼包居然寄到了家里！2025波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/h-MTyHdArK_K6E1OayfT0g",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学offer，我要哭了，现在还在抖~",
                    "link": "https://mp.weixin.qq.com/s/NLieO3fBPT58I5W_VKvUUg",
                    "serial_number": 1
                },
                {
                    "title": "刚刚查了一下：哈佛大学录取我啦！！！",
                    "link": "https://mp.weixin.qq.com/s/zPTioIGyzkuwKQ8V-YbEAA",
                    "serial_number": 1
                },
                {
                    "title": "如约而至：哈佛大学offer！2025相约波士顿！",
                    "link": "https://mp.weixin.qq.com/s/7HHExXv0Glv-pxHyvnvEjQ",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学LDIT，她真的来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/38Ax9N5YxhwpVQNGk7JrMg",
                    "serial_number": 1
                },
                {
                    "title": "火热：Harvard热门全奖offer，终于等到你！",
                    "link": "https://mp.weixin.qq.com/s/MLA3Fe4g_v_KsuoZq19VDQ",
                    "serial_number": 1
                },
                {
                    "title": "哈佛大学肯尼迪，陆本直接拿offer！2025，波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/fIN-uDc-yWQAo0SZVLPTPg",
                    "serial_number": 1
                },
                {
                    "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                    "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                    "serial_number": 1
                },
                {
                    "title": "带奖offer，哈佛大学医学院！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/uUy6Ry40v8tgWEPYKf0zng",
                    "serial_number": 1
                },
                {
                    "title": "今天刚收到offer，来自哈佛大学！2025！",
                    "link": "https://mp.weixin.qq.com/s/6Jjh-jw7aWziUpgD6SuC6g",
                    "serial_number": 1
                },
                {
                    "title": "又是哈佛offer，2025年秋季开学！",
                    "link": "https://mp.weixin.qq.com/s/ocbqiV38xA5J_mhPUrtzww",
                    "serial_number": 1
                }
            ]
        },
        "MIT": {
            cate: "MIT",
            count: "22",
            image: "20220414053442.jpg",
            list: [{
                    "title": "很平淡：MIT全奖热门offer，我2025年入学！",
                    "link": "https://mp.weixin.qq.com/s/Kfh7dLLY6zvv-YSuYOaSdg?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "火热：MIT EECS全奖offer，来自【上科大】！",
                    "link": "https://mp.weixin.qq.com/s/OuQYGhvl6LMk5lCvul9M4Q?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "火热：稳！MIT全奖offer，2025入学！",
                    "link": "https://mp.weixin.qq.com/s/R5GEyTrcnQujToBAGSuF6Q?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "太燃了！MIT打电话给我，全奖offer！",
                    "link": "https://mp.weixin.qq.com/s/YX399Yc2xQP5JiIZF8YNlA?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "我大概率会接：MIT全奖offer，2025！",
                    "link": "https://mp.weixin.qq.com/s/ipFK2HMU7l_ib5BDbfkC3g?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "MIT全额奖学金offer，波士顿我来啦！",
                    "link": "https://mp.weixin.qq.com/s/TQiDLziucbKljlNa0P0_Dg?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "面试后，MIT全奖正式offer，她来啦",
                    "link": "https://mp.weixin.qq.com/s/1azXhGRMJGvxnT6-Kmig5A",
                    "serial_number": 1
                },
                {
                    "title": "天啊！2025，我的第二枚MIT全奖offer！",
                    "link": "https://mp.weixin.qq.com/s/OT-FsG_HYhSrtXrI2ziRrQ?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "果然今天公布结果，MIT商业分析，如约而至",
                    "link": "https://mp.weixin.qq.com/s/-FO9RRl84epKGYB84lwIYg",
                    "serial_number": 1
                },
                {
                    "title": "火热：MIT BA，她终于来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/P77GpeKLmAS-7LbK56r4Gw",
                    "serial_number": 1
                },
                {
                    "title": "火热：MIT金融，8学员集体斩获！波士顿见！",
                    "link": "https://mp.weixin.qq.com/s/XT_OTxlWtyCxiEozwIw7kg",
                    "serial_number": 8
                },
                {
                    "title": "MIT物理学全奖offer，望穿秋水，终于来啦！",
                    "link": "https://mp.weixin.qq.com/s/SwhH9Ac1DcZoj4fRQDzBCA",
                    "serial_number": 1
                },
                {
                    "title": "意想不到啊，MIT居然今天录取我啦！",
                    "link": "https://mp.weixin.qq.com/s/7f6IlvTKm9Dld6Ocd28Hfw",
                    "serial_number": 1
                },
                {
                    "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                    "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                    "serial_number": 1
                }, {
                    "title": "迟来的爱：MIT CS全奖offer！今日抵达！",
                    "link": "https://mp.weixin.qq.com/s/5MUZHUoEUvgsXfdUz5G4vw",
                    "serial_number": 1
                }
            ]
        },
        "Princeton": {
            cate: "Princeton",
            count: "13",
            image: "20220507105046.jpg",
            list: [{
                    "title": "前线战报：同一天2个Princeton全奖offer，2025王子屯见！",
                    "link": "https://mp.weixin.qq.com/s/Sg13cNohPpnT62lB8r1S7g?token=970102990&lang=zh_CN",
                    "serial_number": 2
                },
                {
                    "title": "火热：AI方向，普林斯顿大学全奖！2025！",
                    "link": "https://mp.weixin.qq.com/s/OWe9F5PE9xWIcjRi_A4FmA?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "普林ECE PhD offer再+1！来自【清华】",
                    "link": "https://mp.weixin.qq.com/s/ot-G-D37ZADWGwom6l07YQ?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "多篇AI顶会文章，Princeton全奖来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/mx9HyLRvhj9fRmQHmclfQA?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "运筹与金融工程全奖，普林斯顿大学！2025相约王子屯！",
                    "link": "https://mp.weixin.qq.com/s/fvlVIpkxcUnPxgj4uydyuA",
                    "serial_number": 1
                },
                {
                    "title": "中国大陆录取大多数在这里：Princeton金融，6学员集体斩获！",
                    "link": "https://mp.weixin.qq.com/s/5rz2NoXuJAfFmObLtpyTxg",
                    "serial_number": 6
                },
                {
                    "title": "Princeton全奖offer，她终于终于来啦！",
                    "link": "https://mp.weixin.qq.com/s/mEYSK2tsDXfz3kj10OIpBw",
                    "serial_number": 1
                }
            ]
        },
        "Stanford": {
            cate: "Stanford",
            count: "20",
            image: "20220402105830.jpg",
            list: [{
                "title": "无面试，Stanford全奖offer到啦！2025！",
                "link": "https://mp.weixin.qq.com/s/nvhGZr8xvnFQOYeaL324TQ?token=1525481825&lang=zh_CN",
                "serial_number": 1
            }, {
                "title": "火热！斯坦福大学全额奖学金offer，如约而至！",
                "link": "https://mp.weixin.qq.com/s/rcKMRkkgeGMuuYaqmG_0wA?token=970102990&lang=zh_CN",
                "serial_number": 1
            }, {
                "title": "重磅！梦想实现！斯坦福CS全奖如约而至！",
                "link": "https://mp.weixin.qq.com/s/88MI2irM5tIvO2DrgLUcMQ?token=970102990&lang=zh_CN",
                "serial_number": 1
            }, {
                "title": "情人节礼物：斯坦福大学全奖offer来啦！",
                "link": "https://mp.weixin.qq.com/s/dZF9gEPvfGM_w6Vp4t0wyA?token=309919196&lang=zh_CN",
                "serial_number": 1
            }, {
                "title": "火热：斯坦福大学全额奖学金，2025相约Palo Alto",
                "link": "https://mp.weixin.qq.com/s/qW-xemaSIF9Lt37QzSz_tw",
                "serial_number": 1
            }, {
                "title": "彩票中了：Stanford offer砸中了我！2025加州见！",
                "link": "https://mp.weixin.qq.com/s/6Lu25HKkHQc-NVEhSHOZIg",
                "serial_number": 1
            }, {
                "title": "相约Stanford，我的梦校offer来啦！",
                "link": "https://mp.weixin.qq.com/s/PSThS_IBYSwXKlnoue1xGw",
                "serial_number": 1
            }, {
                "title": "斯坦福大学offer，来自中外合办大学的同学！",
                "link": "https://mp.weixin.qq.com/s/8Le5X78VwzFSZQ2bwV-FlQ",
                "serial_number": 1
            }, {
                "title": "火热：Stanford管理科学，5学员集体斩获！！！",
                "link": "https://mp.weixin.qq.com/s/Q0RW91dEac31C4GITrteug",
                "serial_number": 5
            }, {
                "title": "Stanford管理科学offer+1，6学员集体收获！",
                "link": "https://mp.weixin.qq.com/s/mrJR4g8x8LNeNqHWEu_vFA",
                "serial_number": 1
            }, {
                "title": "Stanford管理科学又+2，8学员集体收获！",
                "link": "https://mp.weixin.qq.com/s/wV02UVNos3aLgRhFc_AapQ",
                "serial_number": 2
            }, {
                "title": "滚烫：Stanford金融数学，3学员集体斩获！",
                "link": "https://mp.weixin.qq.com/s/57m1axmQ5MRpoW6OZsKNKw",
                "serial_number": 3
            }, {
                "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                "serial_number": 1
            }, ]
        },
        "Berkeley": {
            cate: "Berkeley",
            count: "54",
            image: "20220704111303.png",
            list: [{
                    "title": "提交一天，就录取啦！UC Berkeley！2025！",
                    "link": "https://mp.weixin.qq.com/s/X21Uz703S--2zHH7Eb4h8A",
                    "serial_number": 1
                }, {
                    "title": "火热：捷报，Berkeley录取了，2025！！！",
                    "link": "https://mp.weixin.qq.com/s/rYdntQVGJSZs6zdcAEW8gw",
                    "serial_number": 1
                }, {
                    "title": "火热：UC Berkeley录取，加州，我来啦！",
                    "link": "https://mp.weixin.qq.com/s/ketKcYWkUB6dSKCrQML3jA",
                    "serial_number": 1
                }, {
                    "title": "火热：下个学期去哪里？UC Berkeley交换啦！",
                    "link": "https://mp.weixin.qq.com/s/P_1RaQecxezcuajSVvVT1A",
                    "serial_number": 1
                }, {
                    "title": "GPA刚过3.0，Berkeley offer来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/a5f6Ew6vVkQsCocKVAjW3Q",
                    "serial_number": 1
                }, {
                    "title": "GPA 劣势，无 paper，伯克利全奖博士录取！！！",
                    "link": "https://mp.weixin.qq.com/s/36gl8G69qFiytW0rNoTV_Q?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "老天啊！我居然被Berkeley博士录取啦！",
                    "link": "https://mp.weixin.qq.com/s/W2mWZtk1F0nEAFaYMsoW8A?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "MIT全奖后，Berkeley offer也来了",
                    "link": "https://mp.weixin.qq.com/s/yozkRZkry8nYxV3Ryje9vw?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "难度值拉满：Berkeley offer抵达！2025！",
                    "link": "https://mp.weixin.qq.com/s/SEspGh9zc8dVubOVn9ZZnQ?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "AI卷中卷，Berkeley CS全奖offer到啦！",
                    "link": "https://mp.weixin.qq.com/s/Eb8mQcXqvLD0ktQZk-nPPQ?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "AI方向，伯克利CS全奖来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/ks1ak_JCRGBZbYMAiPcM8Q?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "录取率低于5%，Berkeley MDP，两学员集体收获！",
                    "link": "https://mp.weixin.qq.com/s/yiPpGUTYU1PsXaW5FCtE0w?token=309919196&lang=zh_CN",
                    "serial_number": 2
                },
                {
                    "title": "凭暑研实力“出圈”，成功解锁伯克利IEOR PhD offer！",
                    "link": "https://mp.weixin.qq.com/s/KKBpT9fPjQKiQv-irNm87g?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "还能更早？2026入学，Berkeley王牌专业offer来了！",
                    "link": "https://mp.weixin.qq.com/s/I-0-UxGrxh3ynEyf5iQeIg?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "特别开心：Berkeley热门全奖offer！2025秋！",
                    "link": "https://mp.weixin.qq.com/s/MXGNIq0VZT9ifZ3J4PVDBw?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "地狱难度：Berkeley定量社会科学offer，我来啦！",
                    "link": "https://mp.weixin.qq.com/s/XTD-4ZA5b754zuq0hh1wDA",
                    "serial_number": 1
                },
                {
                    "title": "世界之巅：Berkeley全奖博士，她来啦！",
                    "link": "https://mp.weixin.qq.com/s/tUNBe9OWsoSQJmH3P03urA",
                    "serial_number": 1
                },
                {
                    "title": "地狱难度！Berkeley全奖物理学博士offer！2025！",
                    "link": "https://mp.weixin.qq.com/s/jMKuXzpyG6mA4j_zTxAtIg",
                    "serial_number": 1
                },
                {
                    "title": "2026录取：斩获伯克利王牌专业！20,000美元奖学金！",
                    "link": "https://mp.weixin.qq.com/s/SEVa5FULQQDkdDIbO-UUDw",
                    "serial_number": 1
                },
                {
                    "title": "地狱难度：Berkeley公共政策offer，2025！",
                    "link": "https://mp.weixin.qq.com/s/hw8jprOP1DcjU9InhTZNUg",
                    "serial_number": 1
                },
                {
                    "title": "英语系本科，Berkeley统计学offer来啦！！！",
                    "link": "https://mp.weixin.qq.com/s/Vcz49hOJH9AIMXVQs_BJUw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley机器人博士全奖offer，她来啦！！！",
                    "link": "https://mp.weixin.qq.com/s/Fd82QXbQYDLCpjGePatjjQ",
                    "serial_number": 1
                },
                {
                    "title": "火热出炉：Berkeley金融科技，13名学员集体斩获！！！",
                    "link": "https://mp.weixin.qq.com/s/eOAsbS0mgmmxfRqR29Cqxw",
                    "serial_number": 13
                },
                {
                    "title": "行业天花板：Berkeley金融科技，14人集体收获！！！",
                    "link": "https://mp.weixin.qq.com/s/v8m_LoLYS48gHplPKd-dvA",
                    "serial_number": 1
                },
                {
                    "title": "UCLA凌晨拒我，Berkeley早上录我！睡不着了！！！",
                    "link": "https://mp.weixin.qq.com/s/ZjVsfuB36xOPsalOfd93zg",
                    "serial_number": 1
                },
                {
                    "title": "转专业申请BA，Berkeley录取我啦！",
                    "link": "https://mp.weixin.qq.com/s/uCE8oJi5oLlo93X0UMc0ig",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley CS录取，她来啦！2025秋季见！",
                    "link": "https://mp.weixin.qq.com/s/V21aXPJTdOP4DUlA9voj5w",
                    "serial_number": 1
                },
                {
                    "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                    "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                    "serial_number": 1
                },
                {
                    "title": "GPA 75/100，Berkeley录取，来啦！！",
                    "link": "https://mp.weixin.qq.com/s/Jx7UY8y-v7wp2rkqioTCtg",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley热门offer，从211出发！！！！",
                    "link": "https://mp.weixin.qq.com/s/auAhQlzCngJ1vlHYHyG_7g",
                    "serial_number": 1
                },
                {
                    "title": "无面试，直接录！Berkeley热门offer抵达！",
                    "link": "https://mp.weixin.qq.com/s/_fL32lNuudhKDnWGJAV3mQ",
                    "serial_number": 1
                },
                {
                    "title": "哥大金工之后，Berkeley offer也来啦！",
                    "link": "https://mp.weixin.qq.com/s/SrAAu6lNKX1gkBY7SErKRQ",
                    "serial_number": 1
                },
                {
                    "title": "从中财到伯克利！！！毕业生年薪$110K分析学硕士手到擒来",
                    "link": "https://mp.weixin.qq.com/s/G3sqIR4vQDhF1stS10OnUw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley热门offer，来自【上纽大】！2025秋季见！",
                    "link": "https://mp.weixin.qq.com/s/Hw4xBo_VzvOjDNbDZ4yjQw",
                    "serial_number": 1
                },
                {
                    "title": "稳得很，Berkeley热门项目offer抵达！2025！",
                    "link": "https://mp.weixin.qq.com/s/ySv-JOfZE17UD_MkWLJasA",
                    "serial_number": 1
                },
                {
                    "title": "本科交换，UC Berkeley，目标：美国加州！",
                    "link": "https://mp.weixin.qq.com/s/mpNrV16KrfUu3Mrf-9l_MA",
                    "serial_number": 1
                },
                {
                    "title": "UC Berkeley热门offer，从港中文出发！",
                    "link": "https://mp.weixin.qq.com/s/G5A5NMsLqazI2A-yEwLCIQ",
                    "serial_number": 1
                },
                {
                    "title": "笑着流泪：Berkeley offer抵达！2025入学！",
                    "link": "https://mp.weixin.qq.com/s/fZTPrVCC2xthRPif49jnOQ",
                    "serial_number": 1
                },
                {
                    "title": "没错：UC Berkeley全奖offer，相约伯克利！",
                    "link": "https://mp.weixin.qq.com/s/MvWtzoUBxsak5cItl8cHpw",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley热门offer来啦，从中国深圳出发！",
                    "link": "https://mp.weixin.qq.com/s/KTApdwVtQliz512hORvbvQ",
                    "serial_number": 1
                },
                {
                    "title": "Berkeley热门offer，来自上纽大！！！",
                    "link": "https://mp.weixin.qq.com/s/TmBPsxZSkPaQYgvIGlMVWA",
                    "serial_number": 1
                }
            ]
        },
        "CMU": {
            cate: "CMU",
            count: "60",
            image: "20220615102052.jpg",
            list: [{
                    "title": "火热：12月，CMU offer她到啦！2025入学！",
                    "link": "https://mp.weixin.qq.com/s/48Rlw5ZZ2qL3j-lfzNLj6Q",
                    "serial_number": 1
                }, {
                    "title": "2025 offer｜转专业申请！CMU Engineering and Public Policy录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/OtMKVWlJZvbmfAijoiDH7g?token=1525481825&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "火热：CMU offer抵达！来自【西交利物浦】！",
                    "link": "https://mp.weixin.qq.com/s/O_HnVcr035EmfWRHCM426Q?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜除夕迎来牛校offer，CMU计算生物录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/Gg3-zqWu9PXYv8KkriuJTw?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜理工科转专业申请，拿下 CMU公共政策录取！祝贺世毕盟学员！！",
                    "link": "https://mp.weixin.qq.com/s/c6IMRVpQDlFeyzpBWhH-pw?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜理工强校：CMU 机械工程录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/ADow01aFjvjN7YzJwxROmQ?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "起薪16万美元，CMU MCDS，6学员集体斩获！",
                    "link": "https://mp.weixin.qq.com/s/LNN20jpy_xTbNQoMTdwjpQ?token=1748868967&lang=zh_CN",
                    "serial_number": 6
                },
                {
                    "title": "火爆：AI天花板，CMU MSML，5学员集体斩获！",
                    "link": "https://mp.weixin.qq.com/s/yUk1jSiNGT29aIRe7xAIWw?token=1748868967&lang=zh_CN",
                    "serial_number": 5
                },
                {
                    "title": "Robotics天花板，CMU杀疯了，一天13枚offer！",
                    "link": "https://mp.weixin.qq.com/s/6PbWjIdmEGmCaoloRNNf0Q?token=1748868967&lang=zh_CN",
                    "serial_number": 13
                },
                {
                    "title": "地狱难度：CMU LTI博士全奖offer，终于来啦！",
                    "link": "https://mp.weixin.qq.com/s/bI47LfCjPFpmfGppo5R1dA",
                    "serial_number": 1
                },
                {
                    "title": "太卷了！2025 CMU全奖博士录取收入囊中！祝贺世毕盟【国科大】学员！！！",
                    "link": "https://mp.weixin.qq.com/s/Zn4UeXRyJdI8ODetywJVMg",
                    "serial_number": 1
                },
                {
                    "title": "金工天花板：CMU MSCF，10学员集体收获！！！",
                    "link": "https://mp.weixin.qq.com/s/FWNmO4dgUcw4mxIVRiUsFw",
                    "serial_number": 10
                },
                {
                    "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                    "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                    "serial_number": 1
                },
                {
                    "title": "四大神校，终于等到了offer！Waitlist转正！",
                    "link": "https://mp.weixin.qq.com/s/Yo_xzpackDG2XvuiUGVB1Q",
                    "serial_number": 1
                },
                {
                    "title": "CMU热门offer录取，从211出发！",
                    "link": "https://mp.weixin.qq.com/s/ElZMvtTz3_b5JvesAMRrKg",
                    "serial_number": 1
                },
                {
                    "title": "放弃2万留位费，毫不纠结，就去CMU MSCF！！！",
                    "link": "https://mp.weixin.qq.com/s/geJR57kQAhoXgQaIdmOMKA",
                    "serial_number": 1
                },
                {
                    "title": "英文本科转CS，CMU，我来啦！！！！！",
                    "link": "https://mp.weixin.qq.com/s/CRKiK5l2qhBbqRb9sHHQ5Q",
                    "serial_number": 1
                },
                {
                    "title": "经管背景实力突围，喜获CMU 信息系统与管理博士offer！",
                    "link": "https://mp.weixin.qq.com/s/KtUFN4vzQyE-nJXdK35z5w",
                    "serial_number": 1
                },
                {
                    "title": "居然录取了MSML，CMU王牌offer到啦！！！",
                    "link": "https://mp.weixin.qq.com/s/ISfKSXBSRwO-UihSrEJaYw",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer到啦，从西交利物浦出发！",
                    "link": "https://mp.weixin.qq.com/s/mlyLRzKfOtzzrctvp7WdCg",
                    "serial_number": 1
                },
                {
                    "title": "英语专业，转BA，CMU我拿到啦！！！",
                    "link": "https://mp.weixin.qq.com/s/IDIgjvZ7w12dhRWDNy0e7Q",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer来啦，从华科出发！",
                    "link": "https://mp.weixin.qq.com/s/b5JygquNHYjHqgqT1SjA1g",
                    "serial_number": 1
                },
                {
                    "title": "别卷CS了！！科技大厂独家偏爱的CMU BIDA录取我了！！！",
                    "link": "https://mp.weixin.qq.com/s/AnHf7s546kUs-d6r_z6NcA",
                    "serial_number": 1
                },
                {
                    "title": "去CMU，带奖录取，从人大出发！",
                    "link": "https://mp.weixin.qq.com/s/EBlUsfZ7nyByM19ctBojyA",
                    "serial_number": 1
                },
                {
                    "title": "哇！美帝CMU全奖，我来啦！",
                    "link": "https://mp.weixin.qq.com/s/ZZFtYXhRqm5Khw3su6MllA",
                    "serial_number": 1
                },
                {
                    "title": "CMU热门offer到手，从厦门出发！！！",
                    "link": "https://mp.weixin.qq.com/s/PNzmX5uyFFaFTMpUV2mUMQ",
                    "serial_number": 1
                },
                {
                    "title": "斩获CMU BIDA 录取！！！圆梦卡耐基梅隆！",
                    "link": "https://mp.weixin.qq.com/s/N2KUU4pvFk49zOTSU8kffA",
                    "serial_number": 1
                },
                {
                    "title": "CMU, Columbia录取都来啦，从【上海戏剧学院】出发！",
                    "link": "https://mp.weixin.qq.com/s/aDNRX9Png-VBxZNIYm5M-A",
                    "serial_number": 1
                },
                {
                    "title": "去CMU读计算机，从同济出发！",
                    "link": "https://mp.weixin.qq.com/s/2tm_64H6WM3A6eAIFlwPsA",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer到了，我爱CS！",
                    "link": "https://mp.weixin.qq.com/s/y235ml_I7UA6ULAr5qtOhw",
                    "serial_number": 1
                }
            ]
        },
        "Oxford": {
            cate: "Oxford",
            count: "15",
            image: "20220708071402.jpg",
            list: [{
                    "title": "火热：Oxford统计学offer，她来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/VU-WvRgOJpBX3uhNPRqAkw?token=1525481825&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "天啊！除夕当天，牛津大学offer来啦！",
                    "link": "https://mp.weixin.qq.com/s/tu6lBTlCC_NZ0ebSlIlwcw?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "中外合办大学出发，Oxford博士全奖offer抵达的！",
                    "link": "https://mp.weixin.qq.com/s/_LRnMM02mxfERbD2zFx0Hw",
                    "serial_number": 1
                },
                {
                    "title": "天啊，牛津大学临床医学博士offer，来啦！",
                    "link": "https://mp.weixin.qq.com/s/HnxqAn8LcFowo-6Z9y1J7g",
                    "serial_number": 1
                },
                {
                    "title": "感谢世毕盟，我收到牛津大学offer啦！",
                    "link": "https://mp.weixin.qq.com/s/5XEdAC8pP1m105vLxAjHSQ",
                    "serial_number": 1
                },
                {
                    "title": "更新保底校：牛津大学金融经济offer！",
                    "link": "https://mp.weixin.qq.com/s/q5ruoaF7_g7ySKK0lgXHqw",
                    "serial_number": 1
                },
                {
                    "title": "纠结：牛津大学也很好，我该去么？",
                    "link": "https://mp.weixin.qq.com/s/zBB4pwxFn_w0InMFYOSycw",
                    "serial_number": 1
                },
                {
                    "title": "纠结了：牛津大学博士录取了我！2025！",
                    "link": "https://mp.weixin.qq.com/s/P4n1HD1ofloLG5kN21GqAQ",
                    "serial_number": 1
                },
                {
                    "title": "牛津大学CS offer！！！2025秋天见！",
                    "link": "https://mp.weixin.qq.com/s/bC2RLZSErUOA_FUNBC7JkA",
                    "serial_number": 1
                },
                {
                    "title": "牛津大学录取我啦！梦校，梦想成真！",
                    "link": "https://mp.weixin.qq.com/s/6kaM4s5roU3zSU7I128uNw",
                    "serial_number": 1
                },
                {
                    "title": "牛津大学热门offer，2025年秋天见！",
                    "link": "https://mp.weixin.qq.com/s/E6Tv_ngXv7TZDb0ifbDVtA",
                    "serial_number": 1
                },
                {
                    "title": "掌声雷动：牛津大学offer，她来啦！2025 Fall！",
                    "link": "https://mp.weixin.qq.com/s/sV1Z1CjbjtCLc9zeOhUIKQ",
                    "serial_number": 1
                },
                {
                    "title": "火热：剑桥录取之后，牛津大学offer也来啦！哇！",
                    "link": "https://mp.weixin.qq.com/s/dVvEdXsLer_oppo0uuJYVA",
                    "serial_number": 1
                },
                {
                    "title": "没有波澜：牛津大学博士offer，2025秋！",
                    "link": "https://mp.weixin.qq.com/s/-PVadhYVZdKp5EmJ5Fux-Q",
                    "serial_number": 1
                },
                {
                    "title": "四月来信：牛津大学录取，哭了！",
                    "link": "https://mp.weixin.qq.com/s/NNCNFsOXsvAkmpl0bc7BtQ",
                    "serial_number": 1
                }

            ]
        },
        "Cambridge": {
            cate: "Cambridge",
            count: "30",
            image: "20220404074729.jpg",
            list: [{
                    "title": "锁定世毕盟，剑桥大学房地产金融offer到啦！！！",
                    "link": "https://mp.weixin.qq.com/s/gZbaVuqNSAOJznglqOlOVg?token=1525481825&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "火热：剑桥大学机器学习offer，她来啦！",
                    "link": "https://mp.weixin.qq.com/s/BcXKU4DtRcnju-1Y6cDQxQ?token=1748868967&lang=zh_CN",
                    "serial_number": 1
                },
                // {
                //     "title": "2025 offer｜剑桥大学博士Offer！祝贺世毕盟学员！",
                //     "link": "https://mp.weixin.qq.com/s/GPG0U21SV1Lw0BUxiZPDhg",
                //     "serial_number": 1
                // },
                // {
                //     "title": "2025 offer｜剑桥大学金融经济Offer保底！祝贺港本学员！",
                //     "link": "https://mp.weixin.qq.com/s/Etkvou39DrWJVq9TR8OO4g",
                //     "serial_number": 1
                // },
                {
                    "title": "热：剑桥大学offer，2025入学！",
                    "link": "https://mp.weixin.qq.com/s/I1yShIh9vU5yOPJr4sQp4Q?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学金融经济硕士Offer保底！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/n97jLLWOteJ0zA51etmTeg?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "大赞！剑桥大学热门offer抵达！2025！",
                    "link": "https://mp.weixin.qq.com/s/3vhWp3b0J2LhdAGOPx5kUA?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "剑桥金融经济学，她来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/yyM1CQjbch0PnGvwVaxLrQ?token=309919196&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "居然！都没想到，剑桥大学录取我啦！从211出发！",
                    "link": "https://mp.weixin.qq.com/s/bFvuxhS7WE_2TW371Hlzrg",
                    "serial_number": 1
                },
                {
                    "title": "小时候就喜欢剑桥大学，剑桥offer来啦！！！！",
                    "link": "https://mp.weixin.qq.com/s/Yx4hjgDJR8hfysCtzt67vA",
                    "serial_number": 1
                },
                {
                    "title": "从加本到剑桥金融，我来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/BhOtu_j5219nacRJHZU4FQ",
                    "serial_number": 1
                },
                // {
                //     "title": "剑桥大学金融经济硕士，2025，我来啦！",
                //     "link": "https://mp.weixin.qq.com/s/d7XoPrefXU2F4zussdbCzw",
                //     "serial_number": 1
                // },
                {
                    "title": "终于等来了，剑桥大学offer，从同济大学出发！",
                    "link": "https://mp.weixin.qq.com/s/K7BK6t-KO66-j0TT4c0Fdg",
                    "serial_number": 1
                },
                {
                    "title": "很平静：剑桥大学博士offer，2025秋见！",
                    "link": "https://mp.weixin.qq.com/s/5bK3ILG-Gjk3EhoO9vOe8A",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学王牌项目offer来啦！2025秋天见！",
                    "link": "https://mp.weixin.qq.com/s/FABh5OtDyyRwhrUznwSG8g",
                    "serial_number": 1
                },
                {
                    "title": "查了邮箱，突然发现Cambridge offer！2025我来啦！",
                    "link": "https://mp.weixin.qq.com/s/yUw3QDyxxu8BOL4a3i3oiw",
                    "serial_number": 1
                },
                {
                    "title": "毫无波澜，剑桥大学博士offer，她来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/vbG8mSN8yibX4o0GA6LZEw",
                    "serial_number": 1
                },
                {
                    "title": "很平淡：剑桥大学博士offer来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/4JNqKyiQhixQsWm_H_H4wQ",
                    "serial_number": 1
                },
                {
                    "title": "我昨天收到了剑桥大学offer，今年秋天入学！",
                    "link": "https://mp.weixin.qq.com/s/fO2j027y0a_KQgEeVXIusg",
                    "serial_number": 1
                },
                {
                    "title": "剑桥金融经济，offer来啦，2025秋！",
                    "link": "https://mp.weixin.qq.com/s/VcrY8wADyP-X946YwEQc9A",
                    "serial_number": 1
                },
                {
                    "title": "从纽约出发，剑桥大学offer到啦！祝贺美本的同学！",
                    "link": "https://mp.weixin.qq.com/s/Jrs3VN4_E7Mjmnbzkr-KVA",
                    "serial_number": 1
                },
                {
                    "title": "天啊！25 fall第20枚剑桥大学offer！！！！",
                    "link": "https://mp.weixin.qq.com/s/Bv6rnGppd5HvJYuFWkni6A",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学王牌offer，她到啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/AW1ozIQLAzGLkdSUT8Ujbw",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学王牌offer，终于来啦！",
                    "link": "https://mp.weixin.qq.com/s/xxyUvWXdNz9Oxs4kOGAa3w",
                    "serial_number": 1
                },
                {
                    "title": "报告：剑桥大学offer，已经拿下！2025！",
                    "link": "https://mp.weixin.qq.com/s/Ogbl_fTlASp3bwBPc3MKlQ",
                    "serial_number": 1
                },
                {
                    "title": "没错，剑桥大学offer，2025年秋天见！",
                    "link": "https://mp.weixin.qq.com/s/Wh_dyOuTVdfJFYfOAT0lbw",
                    "serial_number": 1
                },
                {
                    "title": "没错，剑桥大学offer，她来啦她来啦！",
                    "link": "https://mp.weixin.qq.com/s/hCvr7Al-1oLGQfgEKKJraA",
                    "serial_number": 1
                },
                {
                    "title": "今年，我迎来了第2个，剑桥大学offer！",
                    "link": "https://mp.weixin.qq.com/s/BIjIGLb9AI-Llnt0_zMeIg",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学商学院offer，我的第二个Cambridge录取！！！",
                    "link": "https://mp.weixin.qq.com/s/5uXf1urx2tobIDv5zNoXgg",
                    "serial_number": 1
                },
                {
                    "title": "Stanford之后，剑桥金融offer也来啦！2025！",
                    "link": "https://mp.weixin.qq.com/s/QTKLTvQl4zA8VtNdLgT6rw",
                    "serial_number": 1
                },
                {
                    "title": "虽迟但到，剑桥大学offer，再见康桥！",
                    "link": "https://mp.weixin.qq.com/s/9_Oa_IXGNOrGl74p6d3g7w",
                    "serial_number": 1
                },
                {
                    "title": "剑桥大学offer再+1！硬核CS PhD offer来啦！",
                    "link": "https://mp.weixin.qq.com/s/ozy9U_QG893aiYTlQwe5mQ",
                    "serial_number": 1
                },
                {
                    "title": "面试一般，居然录啦：剑桥大学offer，秋天见！",
                    "link": "https://mp.weixin.qq.com/s/6z1bC9KEfx8HMbhfYneurw",
                    "serial_number": 1
                }
            ]
        }
    },
    fiveOfferData: {
        "Yale": {
            cate: "Yale",
            count: "32",
            image: "20220514120604.png",
            list: [{
                "title": "火热：耶鲁大学offer，3学员集体斩获！",
                "link": "https://mp.weixin.qq.com/s/3c5kXVgsNnz1WwuVxr7RVA",
                "serial_number": 3
            }, {
                "title": "最新战报：25 Fall第4个耶鲁offer，来自中国广州！",
                "link": "https://mp.weixin.qq.com/s/4NDGRAsEdEyPU_CoTRXQTA",
                "serial_number": 1
            }, {
                "title": "火线速报：耶鲁offer第5个，来自【西交利物浦】！",
                "link": "https://mp.weixin.qq.com/s/0x1rL_-OS4yAuhblLQOHQw",
                "serial_number": 1
            }, {
                "title": "超开心，第6个耶鲁大学offer，抵达！2025！",
                "link": "https://mp.weixin.qq.com/s/yAbV0fpzycVfNpad_mNHDQ",
                "serial_number": 1
            }, {
                "title": "像做梦一样：耶鲁大学博士全奖offer来啦！2025纽黑文！",
                "link": "https://mp.weixin.qq.com/s/uHIva3PE5upUed6q_G8F7w",
                "serial_number": 1
            }, {
                "title": "2025 offer｜人生赢家！从英本到美国藤校！耶鲁大学数据科学录取到！感谢世毕盟指导！",
                "link": "https://mp.weixin.qq.com/s/GMD7bIEPho3F6pU10Zzd8Q",
                "serial_number": 1
            }, {
                "title": "火热：耶鲁大学DS，新年礼物！",
                "link": "https://mp.weixin.qq.com/s/Tu6N2iPkb_ARwR9o0AA54A",
                "serial_number": 1
            }, {
                "title": "耶鲁大学热门offer，我刮到了大彩票！",
                "link": "https://mp.weixin.qq.com/s/zOl5J8jdv915V2pM7WuXtA",
                "serial_number": 1
            }, {
                "title": "耶鲁PEB博士Offer喜报！用实力定义‘跨界王者’！",
                "link": "https://mp.weixin.qq.com/s/GQ1PnMRNCXgoYhNb600EVQ",
                "serial_number": 1
            }, {
                "title": "免面试，直接耶鲁大学全奖offer！2025！",
                "link": "https://mp.weixin.qq.com/s/e4HbMPTzkVm6LaoDAbpj9g",
                "serial_number": 1
            }, {
                "title": "offer来啦，我要去耶鲁大学了！全奖，2025！",
                "link": "https://mp.weixin.qq.com/s/wHF4pYQ6LGd8Ae8itOmMPA",
                "serial_number": 1
            }, {
                "title": "耶鲁大学offer，从浙江大学出发！！！",
                "link": "https://mp.weixin.qq.com/s/uO7emcQsXQnL1tN3rs7QxA",
                "serial_number": 1
            }, {
                "title": "毫无波澜：耶鲁大学CS offer抵达！！！！",
                "link": "https://mp.weixin.qq.com/s/kEGkRSZEGcT_DvUlU3EKvg",
                "serial_number": 1
            }, {
                "title": "耶鲁大学热门offer，2025秋！",
                "link": "https://mp.weixin.qq.com/s/GDivZJ9zz0Smhgc2gqiq0g",
                "serial_number": 1
            }, {
                "title": "CMU之后，耶鲁大学offer也来了！纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/KM8BApEKydROde15nllYhg",
                "serial_number": 1
            }, {
                "title": "今天刷到一个offer，耶鲁大学！2025入学！",
                "link": "https://mp.weixin.qq.com/s/E3SfhVuiI69WG_kzpg2xuQ",
                "serial_number": 1
            }, {
                "title": "耶鲁大学CS offer，又来自【上纽大】！！！",
                "link": "https://mp.weixin.qq.com/s/ZDkBWGuQHj-4mNdPEqsXHw",
                "serial_number": 1
            }, {
                "title": "耶鲁大学热门全奖offer！2025，纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/pSHrJgRnFzha-WPNkoPEWQ",
                "serial_number": 1
            }, {
                "title": "虽然不会去，但是耶鲁大学全奖offer还是来啦！",
                "link": "https://mp.weixin.qq.com/s/bgHAkKC7FKCQI3yvUh_GJw",
                "serial_number": 1
            }, {
                "title": "拿下：耶鲁大学offer，2025秋开学！",
                "link": "https://mp.weixin.qq.com/s/FoT-2AG0knoTIQzQcBXEAw",
                "serial_number": 1
            }, {
                "title": "没有意外，耶鲁大学offer她来啦！",
                "link": "https://mp.weixin.qq.com/s/9MVW1clC-ODdr6dlBz4J8Q",
                "serial_number": 1
            }, {
                "title": "英语本科，强申统计，我去耶鲁大学！！！",
                "link": "https://mp.weixin.qq.com/s/8_2DAjBs4xiZRlmfDoLe1Q",
                "serial_number": 1
            }, {
                "title": "没有波澜：耶鲁大学offer，三月抵达！",
                "link": "https://mp.weixin.qq.com/s/SwLSgsnan5yVcXaAXpBjyQ",
                "serial_number": 1
            }, {
                "title": "火热：Yale商学院AM+2，同时来自上纽大！！！",
                "link": "https://mp.weixin.qq.com/s/uwL4qfTdq8bjw89HTHryGA",
                "serial_number": 2
            }, {
                "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                "serial_number": 1
            }, {
                "title": "来的有点晚：耶鲁大学offer抵达！",
                "link": "https://mp.weixin.qq.com/s/szl21_C6S9qStp2ZBbSSFQ",
                "serial_number": 1
            }, {
                "title": "4月份了，她来啦：耶鲁大学offer！",
                "link": "https://mp.weixin.qq.com/s/CVHHwrzZkF2TG_PVofZMdg",
                "serial_number": 1
            }, {
                "title": "没错：耶鲁大学AM offer！2025纽黑文见！",
                "link": "https://mp.weixin.qq.com/s/7ZupufbP-ygtzzqXiNR99g",
                "serial_number": 1
            }, {
                "title": "还是来啦：耶鲁大学offer，今年秋入学！",
                "link": "https://mp.weixin.qq.com/s/0dDKMmSWcibMsFcb-VLCYQ",
                "serial_number": 1
            }]
        },
        "CMU": {
            cate: "CMU",
            count: "60",
            image: "20220615102052.jpg",
            list: [{
                    "title": "火热：12月，CMU offer她到啦！2025入学！",
                    "link": "https://mp.weixin.qq.com/s/48Rlw5ZZ2qL3j-lfzNLj6Q",
                    "serial_number": 1
                }, {
                    "title": "2025 offer｜转专业申请！CMU Engineering and Public Policy录取来啦！",
                    "link": "https://mp.weixin.qq.com/s/OtMKVWlJZvbmfAijoiDH7g?token=1525481825&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "火热：CMU offer抵达！来自【西交利物浦】！",
                    "link": "https://mp.weixin.qq.com/s/O_HnVcr035EmfWRHCM426Q?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜除夕迎来牛校offer，CMU计算生物录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/Gg3-zqWu9PXYv8KkriuJTw?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜理工科转专业申请，拿下 CMU公共政策录取！祝贺世毕盟学员！！",
                    "link": "https://mp.weixin.qq.com/s/c6IMRVpQDlFeyzpBWhH-pw?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "2025 offer｜理工强校：CMU 机械工程录取！祝贺世毕盟学员！",
                    "link": "https://mp.weixin.qq.com/s/ADow01aFjvjN7YzJwxROmQ?token=970102990&lang=zh_CN",
                    "serial_number": 1
                },
                {
                    "title": "起薪16万美元，CMU MCDS，6学员集体斩获！",
                    "link": "https://mp.weixin.qq.com/s/LNN20jpy_xTbNQoMTdwjpQ?token=1748868967&lang=zh_CN",
                    "serial_number": 6
                },
                {
                    "title": "火爆：AI天花板，CMU MSML，5学员集体斩获！",
                    "link": "https://mp.weixin.qq.com/s/yUk1jSiNGT29aIRe7xAIWw?token=1748868967&lang=zh_CN",
                    "serial_number": 5
                },
                {
                    "title": "Robotics天花板，CMU杀疯了，一天13枚offer！",
                    "link": "https://mp.weixin.qq.com/s/6PbWjIdmEGmCaoloRNNf0Q?token=1748868967&lang=zh_CN",
                    "serial_number": 13
                },
                {
                    "title": "地狱难度：CMU LTI博士全奖offer，终于来啦！",
                    "link": "https://mp.weixin.qq.com/s/bI47LfCjPFpmfGppo5R1dA",
                    "serial_number": 1
                },
                {
                    "title": "太卷了！2025 CMU全奖博士录取收入囊中！祝贺世毕盟【国科大】学员！！！",
                    "link": "https://mp.weixin.qq.com/s/Zn4UeXRyJdI8ODetywJVMg",
                    "serial_number": 1
                },
                {
                    "title": "金工天花板：CMU MSCF，10学员集体收获！！！",
                    "link": "https://mp.weixin.qq.com/s/FWNmO4dgUcw4mxIVRiUsFw",
                    "serial_number": 10
                },
                {
                    "title": "好饭不怕晚：Harvard, MIT, Stanford, Yale，Berkeley横扫！",
                    "link": "https://mp.weixin.qq.com/s/lKtCoiaK43JH_VbrkLQ1Cg",
                    "serial_number": 1
                },
                {
                    "title": "四大神校，终于等到了offer！Waitlist转正！",
                    "link": "https://mp.weixin.qq.com/s/Yo_xzpackDG2XvuiUGVB1Q",
                    "serial_number": 1
                },
                {
                    "title": "CMU热门offer录取，从211出发！",
                    "link": "https://mp.weixin.qq.com/s/ElZMvtTz3_b5JvesAMRrKg",
                    "serial_number": 1
                },
                {
                    "title": "放弃2万留位费，毫不纠结，就去CMU MSCF！！！",
                    "link": "https://mp.weixin.qq.com/s/geJR57kQAhoXgQaIdmOMKA",
                    "serial_number": 1
                },
                {
                    "title": "英文本科转CS，CMU，我来啦！！！！！",
                    "link": "https://mp.weixin.qq.com/s/CRKiK5l2qhBbqRb9sHHQ5Q",
                    "serial_number": 1
                },
                {
                    "title": "经管背景实力突围，喜获CMU 信息系统与管理博士offer！",
                    "link": "https://mp.weixin.qq.com/s/KtUFN4vzQyE-nJXdK35z5w",
                    "serial_number": 1
                },
                {
                    "title": "居然录取了MSML，CMU王牌offer到啦！！！",
                    "link": "https://mp.weixin.qq.com/s/ISfKSXBSRwO-UihSrEJaYw",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer到啦，从西交利物浦出发！",
                    "link": "https://mp.weixin.qq.com/s/mlyLRzKfOtzzrctvp7WdCg",
                    "serial_number": 1
                },
                {
                    "title": "英语专业，转BA，CMU我拿到啦！！！",
                    "link": "https://mp.weixin.qq.com/s/IDIgjvZ7w12dhRWDNy0e7Q",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer来啦，从华科出发！",
                    "link": "https://mp.weixin.qq.com/s/b5JygquNHYjHqgqT1SjA1g",
                    "serial_number": 1
                },
                {
                    "title": "别卷CS了！！科技大厂独家偏爱的CMU BIDA录取我了！！！",
                    "link": "https://mp.weixin.qq.com/s/AnHf7s546kUs-d6r_z6NcA",
                    "serial_number": 1
                },
                {
                    "title": "去CMU，带奖录取，从人大出发！",
                    "link": "https://mp.weixin.qq.com/s/EBlUsfZ7nyByM19ctBojyA",
                    "serial_number": 1
                },
                {
                    "title": "哇！美帝CMU全奖，我来啦！",
                    "link": "https://mp.weixin.qq.com/s/ZZFtYXhRqm5Khw3su6MllA",
                    "serial_number": 1
                },
                {
                     "title": "CMU热门offer到手，从厦门出发！！！",
                    "link": "https://mp.weixin.qq.com/s/PNzmX5uyFFaFTMpUV2mUMQ",
                    "serial_number": 1
                },
                {
                     "title": "斩获CMU BIDA 录取！！！圆梦卡耐基梅隆！",
                    "link": "https://mp.weixin.qq.com/s/N2KUU4pvFk49zOTSU8kffA",
                    "serial_number": 1
                },
                {
                    "title": "CMU, Columbia录取都来啦，从【上海戏剧学院】出发！",
                    "link": "https://mp.weixin.qq.com/s/aDNRX9Png-VBxZNIYm5M-A",
                    "serial_number": 1
                },
                {
                    "title": "去CMU读计算机，从同济出发！",
                    "link": "https://mp.weixin.qq.com/s/2tm_64H6WM3A6eAIFlwPsA",
                    "serial_number": 1
                },
                {
                    "title": "CMU王牌offer到了，我爱CS！",
                    "link": "https://mp.weixin.qq.com/s/y235ml_I7UA6ULAr5qtOhw",
                    "serial_number": 1
                }
            ]
        },
        "LSE": {
            cate: "LSE",
            count: "100+",
            image: "",
            list: []
        },
        "IC": {
            cate: "IC",
            count: "100+",
            image: "",
            list: []
        },
        "UCL": {
            cate: "UCL",
            count: "100+",
            image: "",
            list: []
        }
    }
}